export function translateSpecialCharacters(text: string): string {
  return text
    .toString()
    .replace(/[\u2018\u2019\u201a\u201b\u2032]/g, "'")
    .replace(/[\u2013\u2014\u2015]/g, "-")
    .replace(/[\u2017]/g, "_")
    .replace(/[\u201a]/g, ",")
    .replace(/[\u2026]/g, "...")
    .replace(/[\u201C\u201D\u201E]/g, '"');
}
